module.exports = __webpack_public_path__ + "img/filter-configuration.df644566.png";